export default "__VITE_ASSET__984c2e67__"